var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2D2D2D;}\r\n\t.st1{fill:#7D7D7D;}\r\n\t.st2{fill:#464646;}\r\n\t.st3{fill:#D04A02;}\r\n\t.st4{fill:#E0301E;}\r\n\t.st5{fill:#DB536A;}\r\n\t.st6{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-v2_7_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_6_",
    d: "M73.5,75.9c-0.1,2.8-2.4,5.1-5.3,5.1H35.7c-2.8,0-5.2-2.3-5.3-5.1l-0.8-39.7h-4.5L26,75.9 c0.1,5.3,4.4,9.6,9.8,9.6h32.5c5.3,0,9.6-4.2,9.8-9.6l0.8-39.8h-4.5L73.5,75.9z M81.4,22.5H22.6c-1.2,0-2.3,1-2.3,2.3 s1,2.3,2.3,2.3h58.8c1.2,0,2.3-1,2.3-2.3S82.7,22.5,81.4,22.5z M64.6,18c1.2,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3H39.4 c-1.2,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3H64.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.a35e733be606e90d4ce544300390c48d.svg";
export { ForwardRef as ReactComponent };